import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';
import { isDopDoc, isRequirementFile } from '@/components/Step3/constants';
import { Vicarious } from '@/features/application-review/ui/types';

export interface IDocument {
  allowTypes: string;
  description: string;
  digitalDocument: boolean;
  digitalDocumentNumber: string;
  extraId: string;
  fileCount: number;
  fioPassport: null | string;
  id: number;
  maxFileSize: number;
  name: string;
  orderNum: number;
  required: boolean;
  type: string;
  files: IFile[];
  requirements: IRequirement[];
  isAttachedFile: boolean;
  isRequirements: boolean;
  requirementId: string;
  signatureType: boolean;
  idx: number;
  electronicDocument: boolean;
  documentTemplateForRequests: Record<string, string>[];
  canDeleteDocumentThatHasNotPassedValidation: boolean;
  comment?: string;
  requirementDate?: string;

  documentTemplates: Record<string, string>[];
  formInDocx: any;
  compositeId: string; //Фронтовый, нужен для сортировки
}

interface IDocumentState {
  id: string;
  documents: IDocument[];
}

export interface IRequirement {
  artifactname: string;
  commentEmployee: string;
  completed: boolean;
  createDate: string;
  fileId: null | string;
  id: string;
  isAttachedFile: boolean;
  validated?: boolean;
}

export interface IResponseFile {
  id: string;
  name: string;
  createDate: string;
  validationDate: string | null;
  validated: null | boolean;
  origName: string;
  size: number;
  requirement: null | IRequirement;
  electroDocumentNumber: string | null;
  req: null | boolean;
  lkbExists: boolean; //был ли файл в ЛКБ/отправлен ранее/был в статусе "проверка документов"
  upload?: boolean;
}

export interface IResponseMchd {
  first: Vicarious;
  second: IResponseFile;
}

export function isResponseFile(obj: any): obj is IResponseFile {
  return typeof obj === 'object' && !(obj instanceof Array);
}

export interface IFile extends IResponseFile {
  doctypeid: number;
  templateId: string;
}
export interface IPayloadAddFileToReq {
  i: number;
  j: number;
  file: IFile;
}
export interface IPayloadAddFileToDoc {
  i: number;
  file: IFile;
}
export default <Module<IDocumentState, any>>{
  namespaced: true,
  state: {
    id: '',
    documents: [],
  },
  mutations: {
    setId(state, id: string = '') {
      state.id = id;
    },
    setDocs(state, docs: IDocument[]) {
      docs.forEach((doc, i) => {
        doc.idx = i;
        doc.allowTypes = '.' + doc.allowTypes.split(',').join(',.');
        doc.isRequirements = Boolean(doc.requirements.length && doc.files.length);
        doc.compositeId = doc.id + doc.name;

        if (doc.isRequirements) {
          //todo Исправить fileCount
          // doc.fileCountAbs = doc.fileCount + doc.requirements.length;
          doc.requirements = []; //Пересоздаём заново, чтобы появились ссылки
          doc.files.forEach((file) => {
            if (file.requirement && !file.requirement.completed) {
              file.requirement.isAttachedFile = false;
              doc.requirements.push(file.requirement); //Делаем ссылку
            }
          });
        } else if (doc.digitalDocument) {
          doc.isAttachedFile = !!doc.digitalDocumentNumber || !!doc.files.length;
        } else {
          doc.isAttachedFile = !!doc.files.length;
        }
      });

      state.documents = docs;
    },
    setDigitalDoc(state, { i, number }: { i: number; number: string }) {
      const _doc = state.documents.find((item) => item.idx === i);
      if (_doc) {
        _doc.digitalDocumentNumber = number;
        const attach = !!number;
        _doc.isAttachedFile = !attach && !!_doc.files.length ? true : attach;
      }
    },
    setAttachedDoc(state, { i, val = false }: { i: number; val: boolean }) {
      state.documents[i].isAttachedFile = val;
    },
    /*
    removeFileFromDoc(state, { docIndex, fileId }) {
      const doc = state.documents[docIndex];
      if (doc && doc.files) {
        doc.files = doc.files.filter((file) => file.id !== fileId);
        if (doc.files.length === 0) {
          doc.isAttachedFile = false;
        }
        if (doc.isRequirements && doc.requirements) {
          doc.requirements = doc.requirements.filter((req) => req.fileId !== fileId);
        }
      }
    },
*/
  },
  actions: {
    async getDocuments({ commit, dispatch, rootGetters }, id = rootGetters.appId): Promise<IDocument[]> {
      if (id) {
        return axios
          .get<IDocument[]>(rootGetters.uri.documents(id))
          .then((resp) => {
            const docs = resp.data || [];
            // const docs = (resp.data || [])
            //     .sort((a, b) => {
            //       return a.orderNum - b.orderNum;
            //     })
            //     .sort((a, b) => {
            //       if (getters.isRequirementDoc(a)) return -1;
            //       if (getters.isRequirementDoc(b)) return 1;
            //       return 0;
            //     });

            commit('setDocs', docs);
            return resp.data;
          })
          .catch((e) => {
            e.uri = rootGetters.uri.documents(id);
            dispatch('setError', e, { root: true });
            return Promise.reject(e);
          });
      } else {
        const e = new Error('Нет id');
        dispatch('setError', e, { root: true });
        return Promise.reject(e);
      }
    },
    async processingRequirements({ commit, dispatch, getters, rootGetters }): Promise<void> {
      if (rootGetters.appId != getters.oldId) {
        commit('setId', rootGetters.appId);
        await dispatch('getDocuments');
      }
      return Promise.resolve();
    },
  },
  getters: {
    docs: (state): IDocument[] => state.documents,
    documentsRequired: (state): IDocument[] =>
      state.documents.filter((doc) => (doc.required || doc.isRequirements) && !doc.signatureType),
    documentsNotRequired: (state): IDocument[] =>
      state.documents.filter((doc) => !doc.required && !doc.isRequirements && !doc.signatureType),
    oldId: (state): string => state.id,
    isRequirementDoc:
      (state, getters, rootState, rootGetters) =>
      (doc: IDocument): boolean => {
        return (
          /*doc.required && !doc.files.length ||*/ rootGetters.isAddDocs && (isDopDoc(doc) || isRequirementFile(doc))
        );
      },
  },
};
